var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{ fill:currentcolor;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/hierarchy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/hierarchy-2_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hierarchy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 22.5C20.5449 22.5 22 21.0449 22 19.25C22 17.4551 20.5449 16 18.75 16C16.9551 16 15.5 17.4551 15.5 19.25C15.5 21.0449 16.9551 22.5 18.75 22.5Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19 8.5C20.6569 8.5 22 7.15685 22 5.5C22 3.84315 20.6569 2.5 19 2.5C17.3431 2.5 16 3.84315 16 5.5C16 7.15685 17.3431 8.5 19 8.5Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5 8.5C6.65685 8.5 8 7.15685 8 5.5C8 3.84315 6.65685 2.5 5 2.5C3.34315 2.5 2 3.84315 2 5.5C2 7.15685 3.34315 8.5 5 8.5Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.83049 8.52C5.80049 11.3 8.42049 13.17 11.3705 13.17C11.3805 13.17 11.3905 13.17 11.4005 13.17L14.9305 13.16C16.4505 13.14 17.8105 14.17 18.2205 15.65V17.5C18.2205 17.92 18.5605 18.26 18.9905 18.26C19.4105 18.26 19.7505 17.92 19.7505 17.5V6.26C19.7505 5.84 19.4105 5.5 18.9905 5.5C18.5705 5.5 18.2205 5.84 18.2205 6.26V12.88C17.3405 12.1 16.1905 11.62 14.9405 11.62C14.9305 11.62 14.9305 11.62 14.9205 11.62L11.3905 11.63C11.3805 11.63 11.3805 11.63 11.3705 11.63C9.08049 11.63 7.03049 10.18 6.28049 8.01C6.16049 7.7 5.87049 7.5 5.55049 7.5C5.47049 7.5 5.38049 7.52 5.30049 7.54C4.90049 7.68 4.69049 8.12 4.83049 8.52Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 32,
    height: 32
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.63126d8f3c919c9395f57354f726e0d8.svg";
export { ForwardRef as ReactComponent };